import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";

export default class LocationItem extends DComponent {
  constructor({
    parent,
    id,
    hidePrefix = false,
    centerMode = false,
    isCompact = false,
    location = {},
    onClick = () => { }
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("LocationItem", {
        "hide-country-flag": !location.country?.flag,
        "hide-country-name": !location.country?.flag,
        "hide-country": !location.country,
        "hide-address": !location.address,
        "hide-email": !location.email,
        "hide-phone": !location.phone,
        "hide-prefix": hidePrefix,
        "center-mode": centerMode,
        "is-compact": isCompact
      }),
      countryFlag: location.country?.flag || "",
      countryName: location.country?.name || "",
      city: isCompact ? "" : location.city ? location.city + ", " : "",
      lat: location.lat,
      lng: location.lng,
      ggMaps: location.gg_maps || `https://www.google.com/maps?q=${location.lat},${location.lng}`,
      address: location.address,
      email: location.email,
      phone: location.phone,
    }, true);
    this.location = location;
    this.onClick = onClick;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "LocationItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    $(this.element).on("click", (e) => {
      typeof this.onClick == "function" && this.onClick(this.location.lat, this.location.lng);
    })
  }
}